  // Anmerkung im Warenkorb-Drawer ein-/ausklappen, als ein einziger
  // Klick-Handler am Dokument: Der Knopf entsteht erst mit dem ersten Artikel
  // im Warenkorb. Vorher kam bei jeder Warenkorb-Aenderung ein weiterer
  // Handler hinzu - nach zwei Aenderungen klappte die Anmerkung auf und
  // sofort wieder zu.
  document.addEventListener('click', function (event) {
    var toggleButton = event.target.closest && event.target.closest('#toggle-my-cart_note');
    var descriptionDiv = document.getElementById('my-cart_note');
    if (!toggleButton || !descriptionDiv) return;
    var isExpanded = descriptionDiv.classList.toggle('show');
    toggleButton.textContent = toggleButton.getAttribute(isExpanded ? 'data-hide-text' : 'data-show-text');
  });

  /**
   * Code below is used for restoring a user's cart when being redirected from the configurator.
   */
  function tryRestoreCart() {
    let url = new URL(window.location.href);
    let cartDataRaw = url.searchParams.get('restore_cart');

    if (cartDataRaw == null) return;
    let cartData = JSON.parse(cartDataRaw);

    if (cartData == null) return;

    let formData = {
      'items': [],
      'attributes': {
          'using_configurator__': true
      }
    };

    if (cartData.total) {
      formData.attributes.configurator_cart_total__ = cartData.total;
    }

    for (let variantId in cartData) {
      if (variantId === 'total') continue;
      let quantity = cartData[variantId];

      formData.items.push({
        'id': variantId,
        'quantity': quantity
      })
    }

    // Clear items in cart
    fetch(`${window.Shopify.routes.root}cart/clear.js`, {
      method: 'POST'
    }).then(() => {
      // Add items to cart
      fetch(`${window.Shopify.routes.root}cart/add.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      }).then(() => {
        // Remove restore_cart from url and reload to ensure UI cart is up-to-date
        url.searchParams.delete('restore_cart');

        if (cartData.discount_code) {
          window.location.href = '/discount/' + cartData.discount_code;
          return;
        }
        
        window.location.href = url.toString();
      })
    })
  }

  try {
    tryRestoreCart();
  } catch (ex) {
    console.error(`Error: tryRestoreCart: ${ex}`);
  }